<style scoped>
.additional-content {
  border: 2px solid #dee2e6;
}
</style>

<template>
  <div
    id="additional-content-collapse"
    class="mt-2 col-md-12"
  >
    <div class="additional-content rounded">
      <b-row>
        <b-col class="text-center mt-3">
          <entity-summary :entity="entity" />
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <entity-address :entity="entity" :raised="false" />
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="entityDocs">
        <b-col>
          <entity-documents :entity="entity" :raised="false" :showHint="true"/>
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="borrowerDocs">
        <b-col>
          <div class="p-3">
            <simple-title title="Borrower Documents" />
            <borrower-docs
              :documents="documents"
              :display-links="false"
              :showHint="true"
            />
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>


<script>
import EntityAddress from '@/components/entities/EntityAddress';
import EntitySummary from '@/components/entities/EntitySummary';
import EntityDocuments from '@/components/entities/EntityDocuments';
import BorrowerDocs from '@/components/documents/BorrowerDocs';
import SimpleTitle from '@/components/utils/SimpleTitle';


export default {
  components: {
    EntityAddress,
    EntitySummary,
    EntityDocuments,
    BorrowerDocs,
    SimpleTitle,
  },
  props: {
    entity: Object,
    borrowerDocs: {
      type: Boolean,
      default: true,
    },
    entityDocs: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    documents() {
      const types = ['Bank Statement', 'Tax Returns'];
      return this.$store.getters.documents.filter(doc => types.includes(doc.type));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/application/form/AdditionalContent.vue